import { AxiosRequestConfig } from 'axios'
import { apiService } from './api'

import { normalizeApiPath } from '../utils/apiPath'

/** Normaliza URLs absolutas a rutas relativas para el proxy /api */
function normalizeUrl(url: string): string {
  return normalizeApiPath(url, '/api/v1')
}

/**
 * Fachada retrocompatible: delega en apiService (token vía interceptor).
 * El parámetro `token` se ignora — mantenido para no romper firmas existentes.
 */
export const simpleApiService = {
  get<T>(url: string, _token?: string, options?: { responseType?: 'blob' | 'json' }): Promise<T> {
    const config: AxiosRequestConfig = {}
    if (options?.responseType) {
      config.responseType = options.responseType
    }
    return apiService.get<T>(normalizeUrl(url), config)
  },

  post<T>(url: string, data?: unknown, _token?: string): Promise<T> {
    return apiService.post<T>(normalizeUrl(url), data)
  },

  put<T>(url: string, data?: unknown, _token?: string): Promise<T> {
    return apiService.put<T>(normalizeUrl(url), data)
  },

  patch<T>(url: string, data?: unknown, _token?: string): Promise<T> {
    return apiService.patch<T>(normalizeUrl(url), data)
  },

  delete<T>(url: string, _token?: string): Promise<T> {
    return apiService.delete<T>(normalizeUrl(url))
  },

  upload<T>(url: string, formData: FormData, _token?: string): Promise<T> {
    return apiService.upload<T>(normalizeUrl(url), formData)
  },
}
